// Campaign expiry is based on the shop server response, never the customer's clock.
let shopClock;
function getShopClock(fallbackSeconds) {
  if (!shopClock) {
    shopClock = fetch(window.location.pathname, { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' })
      .then((response) => {
        const serverTime = Date.parse(response.headers.get('Date') || '');
        const age = Number(response.headers.get('Age') || 0);
        if (!Number.isFinite(serverTime)) throw new Error('Missing shop server time');
        return { milliseconds: serverTime + (Number.isFinite(age) ? age * 1000 : 0), monotonic: performance.now() };
      })
      .catch(() => ({ milliseconds: fallbackSeconds * 1000, monotonic: performance.now() }));
  }
  return shopClock;
}
class CampaignWindow extends HTMLElement {
  connectedCallback() {
    this.cancelled = false;
    getShopClock(Number(this.dataset.phServerNow)).then((clock) => {
      if (this.cancelled || !this.isConnected) return;
      const check = () => {
        const now = clock.milliseconds + performance.now() - clock.monotonic;
        const start = Number(this.dataset.phOfferStart) * 1000;
        const end = Number(this.dataset.phOfferEnd) * 1000;
        if (now < start || now >= end) { this.expire(); return; }
        this.expiryTimer = setTimeout(check, Math.min(end - now + 50, 2147483000));
      };
      check();
    });
  }
  disconnectedCallback() { this.cancelled = true; clearTimeout(this.expiryTimer); }
}
class OfferPrice extends CampaignWindow {
  expire() {
    const original = this.querySelector('template[data-ph-normal-price]');
    if (original instanceof HTMLTemplateElement) this.replaceChildren(original.content.cloneNode(true));
  }
}
class CampaignSection extends CampaignWindow { expire() { this.hidden = true; } }
if (!customElements.get('ph-offer-price')) customElements.define('ph-offer-price', OfferPrice);
if (!customElements.get('ph-campaign-section')) customElements.define('ph-campaign-section', CampaignSection);
